import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import moment from "moment";
import { toast } from "react-toastify";
import EmployeePayrollIncrementComponent from "./component/EmployeePayrollIncrementComponent";

const EmployeePayrollIncrement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Update Navbar Heading
  useEffect(() => {
    dispatch(updateNavbarHeading("Employee Payroll Increment"));
  }, [dispatch]);

  const [empOptions, setEmpOptions] = useState([]);
  const [scaleOptions, setScaleOptions] = useState([]);
  const [filterFormData, setFilterFormData] = useState([]); // Ensure this is always an array
  const [payrollLineData, setPayrollLineData] = useState([]);
  const [maxEffectiveDate, setMaxEffectiveDate] = useState(null);
  const [copyPreviousAmount, setCopyPreviousAmount] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [submitting, setSubmitting] = useState(false); // State for the submit loader/disable
  // const [totalOldAmount, setTotalOldAmount] = useState(0);

  useEffect(() => {
    fetchGetApi();
  }, []);

  const fetchGetApi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/change-employee-payroll`
      );

      if (response?.status === 200) {
        const cleanedData = response.data;

        const empListOptions = cleanedData?.employeeListing?.map((ele) => ({
          value: ele.value,
          label: ele.text,
        }));
        setEmpOptions(empListOptions);

        const scaleListOptions = cleanedData?.payrollScales?.map((ele) => ({
          value: ele.value,
          label: ele.text,
        }));
        setScaleOptions(scaleListOptions);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Ensure filterFormData is always treated as an array
  const filteredEmployeeValue =
    filterFormData.find((o) => o.label === "Employee")?.value || 0;
  const filteredScaleValue =
    filterFormData.find((o) => o.label === "Scale")?.value || 0;
  const filteredNewScaleValue =
    filterFormData.find((o) => o.label === "New Scale")?.value || 0;
  const filteredEffectiveDateValue =
    moment(
      filterFormData.find((o) => o.label === "Effective From Date")?.value
    ).format("YYYY-MM-DD") || 0;

  useEffect(() => {
    if (filteredEmployeeValue) {
      fetchScaleID();
    }
  }, [filteredEmployeeValue]);

  const fetchScaleID = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/get-employee-payroll-scale?EmployeeID=${filteredEmployeeValue}`
      );
      const cleanedData = response?.data;
      const getScaleID = cleanedData?.scale;
      const getMaxEffectiveDate = cleanedData?.MysqlFormat;

      setMaxEffectiveDate(getMaxEffectiveDate);

      // Update filterFormData while ensuring it remains an array
      setFilterFormData((prevData) => {
        // Check if "Scale" and "Effective From Date" exist in the array
        const scaleIndex = prevData.findIndex((item) => item.label === "Scale");
        const effectiveDateIndex = prevData.findIndex(
          (item) => item.label === "Effective From Date"
        );

        // Create a copy of the previous data
        const updatedData = [...prevData];

        // Update or add "Scale"
        if (scaleIndex !== -1) {
          updatedData[scaleIndex] = {
            ...updatedData[scaleIndex],
            value: getScaleID,
          };
        } else {
          updatedData.push({ label: "Scale", value: getScaleID });
        }

        // Update or add "Effective From Date"
        if (effectiveDateIndex !== -1) {
          updatedData[effectiveDateIndex] = {
            ...updatedData[effectiveDateIndex],
            value: getMaxEffectiveDate
              ? moment(getMaxEffectiveDate).format("YYYY-MM-DD")
              : null,
          };
        } else {
          updatedData.push({
            label: "Effective From Date",
            value: getMaxEffectiveDate
              ? moment(getMaxEffectiveDate).format("YYYY-MM-DD")
              : null,
          });
        }

        return updatedData;
      });
    } catch (error) {
      console.error("Error fetching scale ID:", error);
    }
  };



  const [apiStatus, SetApiStatus] = useState('')

  const handleGetData = async () => {
    SetApiStatus(undefined)
    if (!filteredNewScaleValue && !filteredEmployeeValue) {
      return (toast.error("New Scale field is required."),
        toast.error("Employee field is required."))
    } else if (!filteredNewScaleValue) {
      return toast.error("New Scale field is required.")
    } else if (!filteredEmployeeValue) {
      return toast.error("Employee field is required.")

    }
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/change-employee-payroll-data?scale_id=${filteredNewScaleValue}&EmployeeID=${filteredEmployeeValue}&newscaleid=${filteredNewScaleValue}&fromdate=${filteredEffectiveDateValue}`
      );
      SetApiStatus(response?.status)
      if (response?.status === 200) {
        const cleanedData = response.data;
        const lineTable = cleanedData?.data;
        setPayrollLineData(lineTable?.map(item=> ({...item,OldAmount:Number(item.OldAmount).toFixed(2)})));
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error);
    }
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setCopyPreviousAmount(isChecked);

    const updatedData = payrollLineData.map((row) => {
      const updatedRow = { ...row };

      if (updatedRow.Amount != null) {
        if (!isNaN(updatedRow.Formula)) {
          // console.log(`✅ Matching Formula: ${row.Formula} `);
          updatedRow.Amount = isChecked
            ? checkIsNaN(updatedRow.OldAmount)
            : 0.0;
          updatedRow.Formula = isChecked
            ? updatedRow.Amount != null
              ? updatedRow.Amount.toString()
              : "0.00"
            : "0.00";
        } else {
          updatedRow.Amount = checkIsNaN(updatedRow.OldAmount);
          // console.log(`❌ Not Matching Formula: ${row.Formula} `);
        }
      } else {
        updatedRow.Amount = 0.0;
        updatedRow.Formula = "0.00";
      }

      return updatedRow;
    });

    setPayrollLineData(updatedData);
  };

  const handleAmountChange = (index, e) => {
    const value = e.target.value;
    const updatedData = [...payrollLineData];
    updatedData[index].Amount = value.trim() === "" ? 0 : value; // Ensure it doesn't become empty
    updatedData[index].Formula = updatedData[index].Amount.toString(); // Keep Formula in sync
    setPayrollLineData(updatedData);
    // setEditedRowData(updatedData[index]);

    // Recalculate the amount using the formula
    calculateByFormula(updatedData[index]);
  };

  const calculateByFormula = (editedRowData) => {
    const model = { ...editedRowData };
    model.Amount = isNaN(model.Amount)
      ? 0
      : model.Amount;
    model.Formula = model.Amount.toString();
    calculatePayrollAmount(model);
  };

  const calculatePayrollAmount = (model) => {
    const payrollsFormula = {};
    const payrollsRoundLevel = {};
    const payrollsRoundVal = {};
    const payrollsType = {};
    // First pass: Collect all payroll data
    payrollLineData.forEach((row) => {
      if (row.Amount == null) return;
      payrollsFormula[row.PayrollCode] = row.Formula || "0";
      payrollsRoundLevel[row.PayrollCode] = row.RoundOffLevel_035 || 0;
      payrollsRoundVal[row.PayrollCode] = Number(row.RoundOffValue) || 0;
      payrollsType[row.PayrollCode] = row.PayrollType_054 || 0;
    });

    // Second pass: Process calculations
    setPayrollLineData((prevData) =>
      prevData.map((row) => {
        const updatedRow = { ...row };

        // FORCE amount to 0 if this is type 619 and skip all calculations
        if (row.PayrollType_054 === 619) {
          updatedRow.Amount = 0;
          return updatedRow;
        }

        // Only process rows that reference the current model
        let formula = row.Formula.replace(/\s+/g, "");
        let payrollsUsed;
        while ((payrollsUsed = formula.match(/\[\w+\]/g))) {
          for (let i = 0; i < payrollsUsed.length; i++) {
            const code = payrollsUsed[i].replace(/\[|\]/g, '');
            if (payrollsFormula[code] !== undefined && payrollsType[code] !== 619) {
              formula = replaceAll(
                formula,
                `[${code}]`,
                `RoundOff(${payrollsFormula[code]},${payrollsRoundLevel[code]},${payrollsRoundVal[code]})`
              );
            } else {
              formula = replaceAll(formula, `[${code}]`, '0');
            }
          }
        }

        try {
          const sanitizedFormula = formula.replace(/if/g, '');
          updatedRow.Amount = RoundOff(
            checkIsNaN(eval(sanitizedFormula)),
            row.RoundOffLevel_035,
            row.RoundOffValue
          );
        } catch (error) {
          console.error("Error evaluating formula:", error);
          updatedRow.Amount = 0;
        }
        return updatedRow;
      })
    );
  };
  const replaceAll = (str, find, replace) => str.split(find).join(replace);

  const checkIsNaN = (value) => (isNaN(value) ? 0 : Number(value));
  const RoundOff = (value, roundLevel, roundValue) => Math.round(value);

  // Function to calculate the footer amount based on the flag
  const calculateFooterAmount = (flag) => {
    return payrollLineData
      .filter(
        (ele) =>
          ele.PayrollType_054 === 941 ||
          ele.PayrollType_054 === 942 ||
          ele.PayrollType_054 === 1026
      )
      .reduce(
        (sum, ele) => sum + checkIsNaN(flag ? ele.Amount : ele.OldAmount),
        0
      );
  };

  useEffect(() => {
    setTotalAmount(calculateFooterAmount(1)); // Calculate totalAmount based on Amount field
  }, [payrollLineData]);

  const totalOldAmount = calculateFooterAmount(0); // Calculate totalOldAmount based on OldAmount field
  
  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    
    // Validate data presence
    if (!payrollLineData || payrollLineData.length === 0) {
      toast.error("No data available to submit.");
      return;
    }

    setSubmitting(true); // Disable button and start loader

    try {
      const payload = {
        EmployeePayrollLine: payrollLineData,
      };

      const response = await PostServiceCaller(
        `${API_URL}rujul/finance/change-employee-payroll`,
        payload,
        "post"
      );

      if (response?.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => { window.location.reload() }, 2000)
      } else {
        console.error("Failed to submit data status:", response?.status);
        toast.error("Submission failed. Please try again.");
        setSubmitting(false); // Re-enable button on error
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
      toast.error("An unexpected error occurred.");
      setSubmitting(false); // Re-enable button on error
    }
  };

  const formDatas = [
    { name: "Employee", type: "Select", options: empOptions },
    { name: "Scale", type: "Select", show: true, options: scaleOptions },
    { name: "New Scale", type: "Select", options: scaleOptions },
    { name: "Effective From Date", type: "Date" },
  ];

  const handleChange = (e, name) => {
    setFilterFormData((prevFormData) => {
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      if (existingLabelIndex !== -1) {
        return prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
      } else {
        return [
          ...prevFormData,
          { label: name, value: e.value !== undefined ? e.value : e },
        ];
      }
    });
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className=" rounded bg-white" id="skill-table-area">
        <div className="row mt-2">
          <EmployeePayrollIncrementComponent
            isAddNewBtnRequired={true}
            isFilterRequired={true}
            handleGetData={handleGetData}
            handleAddNew={handleSubmit}
            isApiStatus={apiStatus}
            handleChange={handleChange}
            formDatas={formDatas}
            filterFormData={filterFormData}
            handleCheckboxChange={handleCheckboxChange}
            handleAmountChange={handleAmountChange}
            payrollLineData={payrollLineData}
            copyPreviousAmount={copyPreviousAmount}
            totalOldAmount={totalOldAmount}
            totalAmount={totalAmount}
            isSubmitting={submitting} // Key change: button inside child component must use this prop
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeePayrollIncrement;